import React, { useState, useEffect } from 'react'
import { AIModalType } from '../hooks/useAIMessageModal'
import {
  CustomerAlertModal,
  SalesOpportunityModal,
  PolicyReminderModal,
  AppointmentModal,
  SalesReportModal
} from './AIMessageModals'
import { InternalMessageModal } from './InternalMessageModal'
import { usePopup } from '@/contexts/PopupContext'
import { useChatbot } from '@/contexts/ChatbotContext'

interface AIMessageModalProps {
  isOpen: boolean
  onClose: () => void
  type: AIModalType
  message: any
}

export const AIMessageModal: React.FC<AIMessageModalProps> = ({
  isOpen,
  onClose,
  type,
  message
}) => {
  const { openPopup, closePopup } = usePopup()
  const { setIsChatbotVisible } = useChatbot()
  const prevIsOpen = React.useRef(isOpen)
  const [selectedAction, setSelectedAction] = useState<string | null>(null)

  // Reset selectedAction khi mở lại popup
  useEffect(() => {
    if (isOpen) {
      setSelectedAction(null)
    }
  }, [isOpen])

  useEffect(() => {
    if (!prevIsOpen.current && isOpen) {
      openPopup()
      setIsChatbotVisible(false)
    }
    if (prevIsOpen.current && !isOpen) {
      closePopup()
      setIsChatbotVisible(true)
    }
    prevIsOpen.current = isOpen
  }, [isOpen, setIsChatbotVisible])

  const modalActions = {
    onClose,
    onActionSelect: (actionType: string) => setSelectedAction(actionType),
    selectedAction
  }

  if (!message) return null

  switch (type) {
    case 'customer-alert':
      return <CustomerAlertModal message={message} modalActions={modalActions} isOpen={isOpen} />
    case 'sales-opportunity':
      return <SalesOpportunityModal message={message} modalActions={modalActions} isOpen={isOpen} />
    case 'policy':
      return <PolicyReminderModal message={message} modalActions={modalActions} isOpen={isOpen} />
    case 'appointment':
      return <AppointmentModal message={message} modalActions={modalActions} isOpen={isOpen} />
    case 'sales-report':
      return <SalesReportModal message={message} modalActions={modalActions} isOpen={isOpen} />
    case 'internal':
      return <InternalMessageModal message={message} modalActions={modalActions} isOpen={isOpen} />
    default:
      return null
  }
} 